import type { FC } from "react";

const CheckOutDialog: FC<{
  open: boolean;
  loading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}> = ({ open, loading, onConfirm, onCancel }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-6 backdrop-blur-sm">
      <div className="bc-fade-up w-full max-w-sm overflow-hidden rounded-2xl border border-white/[0.08] bg-primaryBlueShade">
        <div className="border-b border-amber-500/20 bg-amber-500/[0.06] px-6 py-5 text-center">
          <div className="mx-auto mb-3 flex size-12 items-center justify-center rounded-full border border-amber-500/30 bg-amber-500/10">
            <svg
              className="size-6 text-amber-400"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
          </div>
          <h3 className="font-oswald text-xl font-medium uppercase tracking-wide text-white">
            Confirm Check-Out
          </h3>
          <p className="mt-2 text-sm text-white/40">
            This action cannot be undone.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-3 p-5">
          <button
            onClick={onCancel}
            disabled={loading}
            className="rounded-lg border border-white/[0.08] bg-white/[0.03] px-4 py-3 text-sm font-semibold text-white/50 transition-all active:scale-[0.97]"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="rounded-lg bg-amber-500 px-4 py-3 text-sm font-bold text-primaryDarkBlue transition-all active:scale-[0.97] disabled:opacity-50"
          >
            {loading ? "Processing..." : "Check Out"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckOutDialog;
